// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function description(t) {
  return t.description;
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          description: undefined
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          description: t.description
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          name: t.name,
          description: description
        };
}

function fromJson(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          description: Json_decode.field("description", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "description",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.description)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

exports.id = id;
exports.name = name;
exports.description = description;
exports.empty = empty;
exports.setName = setName;
exports.setDescription = setDescription;
exports.fromJson = fromJson;
exports.encode = encode;
/* No side effect */
